<template>
  <div class="upload_div" v-show="visibleControl">
    <div class="upload_docs" v-show="visibleControl">
      <div style="margin-top: 7px; background-color:#c1daef;padding:5px">
        <div id="divSubDoctype" class="dClass">
          Select Doc Type
          <select
            id="ddlSubDocType"
            v-model="subDTID"
            v-on:change="subDocTypeChange()"
            style="width: 75%;margin-left: 10px;"
          >
            <option
              v-for=" item in subDocType"
              v-bind:key="item.subDocTypeID"
              v-bind:value="item.subDocTypeID"
            >{{ item.subDocTypeName }}</option>
          </select>
        </div>
      </div>
      <div>
        <a class="control_close" v-on:click="closeControl()">Close</a>
        <span class="sizeMax" title="Max 1MB per document">Max size 1 MB per document</span>
      </div>
      <div class="control-data">
        <div>
          <div id="drop_area" class="drop_area" v-on:click="showFileDialog()">
            <span class="file_drop">Click / Drag and drop file here for upload</span>
            <input
              type="file"
              ref="uploadFiles"
              multiple
              style="display:none"
              v-on:change="uploadFile()"
            />
          </div>
          <div style="text-align:center">
            <input type="button" value="Upload Documents" v-on:click="uploadDoc()" />
          </div>
        </div>
        <div class="preview_content" style>
          <!-- <div class="Flex_Table" width="100%">
          <div class="Flex_Row" v-for="upfile in upFiles">
            <div class="Flex_Cell" width="80%">{{upfile.fileName}}</div>
            <div class="Flex_Cell" width="20%">
              <img alt="File Preview" v-bind:src="upfile.filePreview" class="file_preview" />
            </div>
            <div class="Flex_Cell" width="20%">{{upfile.percent}}%</div>
          </div>
          </div>-->
          <div class="file_row">
            <div v-for="upfile in upFiles" class="file_column">
              <span
                class="del_img"
                title="Click to delete upload file"
                v-if="!upfile.isApproved"
                v-on:click="deleteUploadFile(upfile)"
              >X</span>
              <span class="file_name">{{ upfile.fileName }}</span>
              <center>
                <div
                  class="preview_div"
                  :class="{ error_upload: upfile.isUplodError }"
                  v-bind:title="upfile.fileName"
                  v-on:click="openDocImage(upfile)"
                >
                  <img alt="File Preview" v-bind:src="upfile.filePreview" class="file_preview" />
                  <div class="percent_div" v-if="upfile.empDocID == '-1'">{{ upfile.percent }}%</div>
                </div>
              </center>
            </div>
          </div>
        </div>
        <div class="file_count">{{ countSummary }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import axios from "axios";
import config from "@/router/globalConfig";
// import lbl from "@/router/globalLabel";
const newLocal = new FormData();
export default {
  name: "FileUpload",
  props: {
    ShowControl: { type: Boolean, default: false },
    IsSubmit: { type: Boolean, default: false },
    EmpID: { type: String, default: "-1" },
    CommonID: { type: String, default: "-1" },
    DocTypeID: { type: String, default: "-1" },
    SubDocTypeID: { type: String, default: "-1" },
    QualID: { type: String, default: "-1" },
    ExpID: { type: String, default: "-1" }
  },
  data() {
    return {
      upFiles: [],
      visibleControl: false,
      subDocType: "",
      subDTID: "-1",
      type: "1",
      countSummary: "",
      windowPreview: null
    };
  },
  methods: {
    showFileDialog() {
      if (this.IsSubmit) {
        alert("After submit for approval no updation allowed.");
        return false;
      }
      this.$refs.uploadFiles.value = "";
      this.$refs.uploadFiles.click();
    },
    uploadFile() {
      var ext = ["PNG", "JPG", "JPEG", "BMP", "GIF", "ICO"];
      //this.upFiles = [];
      var me = this;
      var myFiles = [];
      var lstFiles = this.$refs.uploadFiles.files;
      var isValidExtension = true;
      var isValidSize = true;
      var checkSize = parseFloat(1024 * 1024);
      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) > checkSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type. only image files are upload");
        return false;
      }

      if (isValidSize == false) {
        alert("Individual image files size are more than 1 MB.");
        return false;
      }

      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.file = element;
          object.filePreview = e.target.result;
          object.fileName = fName;
          object.percent = 0;
          object.empDocID = "-1";
          object.isUplodError = false;
          object.isApproved = false;
          me.upFiles.push(object);
        });

        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        } else {
          var object = new Object();
          object.file = element;
          // file preview icon settings
          var imgData;
          if (fileExt.toUpperCase() == "PDF") {
            imgData = require("@/assets/images/icon/pdf.png");
          } else if (fileExt.toUpperCase() == "TXT") {
            imgData = require("@/assets/images/icon/txt.png");
          } else if (
            fileExt.toUpperCase() == "DOC" ||
            fileExt.toUpperCase() == "DOCX"
          ) {
            imgData = require("@/assets/images/icon/word.png");
          } else if (
            fileExt.toUpperCase() == "XLS" ||
            fileExt.toUpperCase() == "XLSX"
          ) {
            imgData = require("@/assets/images/icon/xls.png");
          } else if (
            fileExt.toUpperCase() == "PPT" ||
            fileExt.toUpperCase() == "PPTX"
          ) {
            imgData = require("@/assets/images/icon/ppt.png");
          } else if (fileExt.toUpperCase() == "CSV") {
            imgData = require("@/assets/images/icon/csv.png");
          } else if (fileExt.toUpperCase() == "MP4") {
            imgData = require("@/assets/images/icon/mp4.png");
          } else {
            imgData = require("@/assets/images/icon/unknown.png");
          }
          object.filePreview = imgData;
          object.fileName = fName;
          object.percent = 0;
          object.empDocID = "-1";
          object.isUplodError = false;
          object.isApproved = false;
          me.upFiles.push(object);
        }
      });
      this.$refs.uploadFiles.value = "";
      /*
      for (var i = 0; i < myFiles.length; i++) {
        var object = new Object();
        object.file = myFiles[i];
        object.filePreview = "";
        object.fileName = myFiles[i].name;
        object.percent = 0;
        this.upFiles.push(object);
      }
      this.upFiles.forEach(element => {
        var reader = new FileReader();
        reader.onload(function(e) {
          element.filePreview = e.target.result;
        });
        reader.readAsDataURL(element.file);
      });
      */
    },
    uploadDoc() {
      if (this.IsSubmit) {
        alert("After submit for approval no updation allowed.");
        return false;
      }
      var me = this;
      this.upFiles.forEach(function(item, index) {
        if (item.empDocID == "-1") {
          var objData = new Object();
          objData.EmpDocID = "-1";
          objData.EmpID = me.EmpID;
          objData.QualID = me.QualID;
          objData.CommonID = me.CommonID;
          objData.DocType = me.DocTypeID;
          objData.SubDocType = me.subDTID;
          objData.ExperienceTypeID = me.ExpID;
          objData.DocNo = "0";
          objData.IsForDel = false;
          objData.LetterNo = "";
          objData.LetterFileName = item.fileName;
          objData.Type = 1;

          var formData = new FormData();
          formData.append("FileInfoData", JSON.stringify(objData));
          formData.append("file", item.file);
          axios.defaults.headers.common["Authorization"] = config.LOG_Token;
          axios.defaults.headers.common["__RequestVerificationToken"] =
            config.AF_Token;
          axios
            .post(config.WEB_API_PATH + "DocUpload/UploadFile", formData, {
              onUploadProgress: function(progressEvent) {
                item.percent = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }.bind(me),
              crossdomain: true
            })
            .then(
              response => {
                //alert(JSON.stringify(response));
                item.empDocID = response.data.result1;
                item.isUplodError = false;
              },
              error => {
                if (error.response == undefined) {
                  alert("Error: " + error);
                } else {
                  if (error.response.data.message == undefined) {
                    alert("Error: " + error.response.data);
                  } else {
                    alert("Error: " + error.response.data.message);
                  }
                }
                item.percent = 0;
                item.isUplodError = true;
              },
              failure => {
                alert("Failure: " + failure);
                item.percent = 0;
                item.isUplodError = true;
              }
            );
        }
      });
    },
    deleteUploadFile(file) {
      let cnfResult = confirm("Are you sure to delete uploaded file?");
      if (cnfResult == false) {
        return false;
      }
      if (this.IsSubmit) {
        alert("After submit for approval no delete opration allowed.");
        return false;
      }
      if (file.empDocID == -1) {
        //alert(this.upFiles.indexOf(file));
        this.upFiles = this.upFiles.filter(obj => obj != file);
        return false;
      }
      var objData = new Object();
      objData.EmpDocID = file.empDocID;
      objData.EmpID = this.EmpID;
      objData.QualID = this.QualID;
      objData.CommonID = this.CommonID;
      objData.DocType = this.DocTypeID;
      objData.SubDocType = this.subDTID;
      objData.ExperienceTypeID = this.ExpID;
      objData.DocNo = "0";
      objData.IsForDel = true;
      objData.LetterNo = "";
      objData.LetterFileName = "";
      objData.Type = 1;

      var formData = new FormData();
      formData.append("FileInfoData", JSON.stringify(objData));
      axios.defaults.headers.common["Authorization"] = config.LOG_Token;
      axios.defaults.headers.common["__RequestVerificationToken"] =
        config.AF_Token;
      axios
        .post(config.WEB_API_PATH + "DocUpload/DeleteFile", formData, {
          crossdomain: true
        })
        .then(
          response => {
            this.upFiles = this.upFiles.filter(
              obj => obj.empDocID != file.empDocID
            );
          },
          error => {
            if (error.response == undefined) {
              alert("Error: " + error);
            } else {
              if (error.response.data.message == undefined) {
                alert("Error: " + error.response.data);
              } else {
                alert("Error: " + error.response.data.message);
              }
            }
          },
          failure => {
            alert("Failure: " + failure);
          }
        );
    },
    closeControl() {
      this.visibleControl = false;
      this.$emit("hideControl", false);
    },
    registerEvent() {
      var dropArea = document.getElementById("drop_area");
      dropArea.addEventListener("dragenter", this.preventDefaults, false);
      dropArea.addEventListener("dragover", this.preventDefaults, false);
      dropArea.addEventListener("dragleave", this.preventDefaults, false);
      dropArea.addEventListener("drop", this.preventDefaults, false);
      dropArea.addEventListener("drop", this.handleDrop, false);
    },
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    handleDrop(e) {
      this.upFiles = [];
      var me = this;
      var myFiles = [];
      let dt = e.dataTransfer;
      var lstFiles = dt.files;
      for (var i = 0; i < lstFiles.length; i++) {
        myFiles.push(lstFiles[i]);
      }
      myFiles.forEach(element => {
        var ext = ["PNG", "JPG", "JPEG", "BMP", "GIF", "ICO"];
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.file = element;
          object.filePreview = e.target.result;
          object.fileName = fName;
          object.percent = 0;
          object.empDocID = "-1";
          object.isUplodError = false;
          object.isApproved = false;
          me.upFiles.push(object);
        });

        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        } else {
          var object = new Object();
          object.file = element;
          // file preview icon settings
          var imgData;
          if (fileExt.toUpperCase() == "PDF") {
            imgData = require("@/assets/images/icon/pdf.png");
          } else if (fileExt.toUpperCase() == "TXT") {
            imgData = require("@/assets/images/icon/txt.png");
          } else if (
            fileExt.toUpperCase() == "DOC" ||
            fileExt.toUpperCase() == "DOCX"
          ) {
            imgData = require("@/assets/images/icon/word.png");
          } else if (
            fileExt.toUpperCase() == "XLS" ||
            fileExt.toUpperCase() == "XLSX"
          ) {
            imgData = require("@/assets/images/icon/xls.png");
          } else if (
            fileExt.toUpperCase() == "PPT" ||
            fileExt.toUpperCase() == "PPTX"
          ) {
            imgData = require("@/assets/images/icon/ppt.png");
          } else if (fileExt.toUpperCase() == "CSV") {
            imgData = require("@/assets/images/icon/csv.png");
          } else if (fileExt.toUpperCase() == "MP4") {
            imgData = require("@/assets/images/icon/mp4.png");
          } else {
            imgData = require("@/assets/images/icon/unknown.png");
          }
          object.filePreview = imgData;
          object.fileName = fName;
          object.percent = 0;
          object.empDocID = "-1";
          object.isUplodError = false;
          object.isApproved = false;
          me.upFiles.push(object);
        }
      });
    },
    getSubDocType() {
      //alert(this.DocTypeID);
      axios
        .get(config.WEB_API_PATH + "HRInfo/GetSubDocType", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: {
            subDocTypeID: "-1",
            docTypeID: this.DocTypeID,
            type: 1
          },
          crossdomain: true
        })
        .then(
          result => {
            this.subDocType = result.data;
            if (this.subDocType.length > 0) {
              if (this.subDTID == "-1") {
                this.subDTID = this.subDocType[0].subDocTypeID;
              }
              this.subDocTypeChange();
            }
          },
          error => {
            alert("Error: " + error);
          },
          failure => {
            alert("Failure: " + failure);
          }
        )
        .catch(function(error) {
          alert(error);
        });
    },
    subDocTypeChange() {
      this.upFiles = [];
      this.countSummary = "";
      axios
        .get(config.WEB_API_PATH + "HRInfo/GetEmpDocComma", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: {
            empDocID: "-1",
            empID: this.EmpID,
            docTypeID: this.DocTypeID,
            subDocTypeID: this.subDTID,
            qualID: this.QualID,
            commonID: this.CommonID,
            type: 4
          },
          crossdomain: true
        })
        .then(
          result => {
            let me = this;
            let fileList = result.data;
            fileList.forEach(element => {
              var object = new Object();
              object.file = null;
              object.filePreview = ""; //me.loadFile(element.empDocIDComma);
              object.fileName = element.letterFileNameComma;
              object.percent = 0;
              object.empDocID = element.empDocIDComma;
              object.isUplodError = false;
              object.isApproved = element.isApproved;
              me.upFiles.push(object);
              this.countSummary = element.docCountComma;
            });

            this.loadFile();
          },
          error => {
            alert("Error: " + error);
          },
          failure => {
            alert("Failure: " + failure);
          }
        )
        .catch(function(error) {
          alert(error);
        });
    },
    loadFile() {
      let me = this;
      me.upFiles.forEach(element => {
        axios
          .get(config.WEB_API_PATH + "DocUpload/GetFile", {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token
            },
            params: {
              empDocID: element.empDocID,
              type: 1
            },
            crossdomain: true
          })
          .then(
            result => {
              element.filePreview = result.data;
            },
            error => {
              alert("Error: " + error);
            },
            failure => {
              alert("Failure: " + failure);
            }
          )
          .catch(function(error) {
            alert(error);
          });
      });
    },
    openDocImage(file) {
      var img = new Image();
      img.src = file.filePreview;
      this.windowPreview;
      if (this.windowPreview != null) {
        this.windowPreview.close();
      }
      this.windowPreview = window.open(
        "",
        "FilePreview",
        "scrollbars,addressbar=no,location=no,resizable=yes,width=550px,height=600px,left=10,top=10"
      );
      this.windowPreview.document.write(img.outerHTML);
    }
  },
  mounted() {
    this.registerEvent();
    //alert(this.CommonID);
  },
  watch: {
    ShowControl(newValue, oldValue) {
      this.visibleControl = newValue;
      if (newValue == true) {
        this.getSubDocType();
      }
    },
    DocTypeID(newValue, oldValue) {
      //this.getSubDocType();
    },
    CommonID(newValue, oldValue) {
      //this.getSubDocType();
    },
    SubDocTypeID(newValue, oldValue) {
      this.subDTID = newValue;
    }
  }
};
</script>
<style>
.upload_div {
  background-color: rgba(131, 133, 117, 0.2);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 999999;
}

.upload_docs {
  background-color: #8385b1;
  border: 1px solid #c7c7c7;
  top: 50%;
  left: 50%;
  padding: 5px 0px 5px 0px;
  position: absolute;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  z-index: 2005;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 3px 3px 3px #b8b8b8;
  -webkit-box-shadow: 3px 3px 3px #b8b8b8;
  box-shadow: 3px 3px 3px #b8b8b8;
  height: 500px;
  width: 700px;
}

a {
  cursor: pointer;
  text-decoration: none;
}

#backgroundPopup {
  display: none;
  position: fixed;
  _position: absolute;
  /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
}

.control_close {
  font-size: 14px;
  line-height: 14px;
  right: -14px;
  top: -15px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 9px;
  cursor: pointer;
}

.sizeMax {
  font-size: 14px;
  line-height: 14px;
  top: -14px;
  position: absolute;
  color: black;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: #dfe2e2;
  border-radius: 3px;
  left: -1px;
}

.control-data {
  margin-top: 10px;
}

.drop_area {
  height: 100px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}

.file_drop {
  font-size: 20px;
}

.preview_content {
  background-color: #62616f;
  border-radius: 3px;
  margin: 3px;
  height: 40vh;
  width: 99%;
  overflow: auto;
}

.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
}

.file_row:after {
  content: "";
  display: table;
  clear: both;
}

.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: 20px;
  z-index: 5001;
}

.del_img:hover {
  background-color: #fb0bbf;
}

.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}

.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}

.file_preview {
  height: 80px;
  width: 80px;
}

.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  color: #f3dbdb;
}

.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.error_upload {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ekkControls/FileUpload.vue